import { companySlice } from "./slice";

export default companySlice.actions;
